import HTTP from "@/_helpers/http";
import { TRADABLEBONUS__API } from "@/_helpers/urls";
import { TRADABLEBONUS__MUTATIONS } from "../mutation-types";
import { TRADABLEBONUS__ACTIONS } from "../action-types";

const state = {
  tradablebonus: [],
  trades: [],
  dashboardClosedTradesData: {
    total: 0,
    totalProfit: 0,
    totalVolume: 0
  },
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  },
  summaries: {
    totalProfit: 0,
    totalVolume: 0,
    totalEquity: 0
  },
  isLoading: false,
};

const getters = {};

const mutations = {

  [TRADABLEBONUS__MUTATIONS.TRADABLEBONUSHISTORY](state, data) {

    // Update trades
    state.trades = data?.data?.trades || [];

    // Update pagination
    state.pagination = data?.data?.pagination || {
      total: 0,
      perPage: 10,
      currentPage: 1,
      lastPage: 1
    };

    // Update summaries
    state.summaries = data?.data?.summaries || {
      totalProfit: 0,
      totalVolume: 0,
      totalEquity: 0
    };

    state.lastUpdate = new Date().toISOString();
  },

  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
};

const actions = {
  async [TRADABLEBONUS__ACTIONS.TRADABLEBONUSHISTORY]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        page = 1,
        limit = 10,
        trading_account_type_id,
        search = "",
        duration
      } = parameter || {};

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trading_account_type_id && { trading_account_type_id }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();

      const url = `${TRADABLEBONUS__API.TRADABLEBONUSHISTORY}${queryParams ? `?${queryParams}` : ''}`;
      
      console.log("Fetching from URL:", url); // ✅ log the final URL
      const response = await HTTP().get(url);

      console.log("API response:", response.data); // ✅ log API response

      commit(TRADABLEBONUS__MUTATIONS.TRADABLEBONUSHISTORY, response.data);
    } catch (error) {
      console.error("Error fetching live trades:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async [TRADABLEBONUS__ACTIONS.DIRECTPROVIDETRADABLEBONUS]({ dispatch }, data) {
    try {
      const response = await HTTP().post(`${TRADABLEBONUS__API.DIRECTPROVIDETRADABLEBONUS}`, data);
      return response.data;
      // ✅ Check response.data.status explicitly
      // if (response.data.status === true) {
      //   await dispatch(TRADABLEBONUS__ACTIONS.USERTRADINGACCOUNTS, {
      //     client_account_id: data.client_account_id
      //   });
      //   toast.success(response.data.message || "Bonus provided successfully!");
      // } else {
      //   toast.error(response.data.message || "Something went wrong.");
      // }
    } catch (error) {
      throw error.response?.data || { message: "Something went wrong." };
      // ✅ Catch network/server errors
      // const errMessage =
      //   error.response?.data?.message || error.message || "Something went wrong.";
      // toast.error(errMessage);
    }
  }

};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions
};
